/**
 * @description
 * This function is used to get the value of a search param key
 * when the params string is before the hash
 * (e.g., `https://www.example.com?param1=value1&param2=value2#/path`).
 *
 * If the param key is not found, an empty string is returned.
 */
export const getSearchParamValue = ({ paramKey }: { paramKey: string }): string => {
  // #NOTES
  // Please note that the `useSearchParams` hook does not work in this case
  // because it only handles the params string after the hash.
  const paramsString = window.location.search;

  const searchParams = new URLSearchParams(paramsString);
  const value = searchParams.get(paramKey);
  return value || '';
};
